import React from 'react'
import propTypes from 'prop-types'
import Header from './header'
import Footer from '../footer'
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'

export const frontTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#103562'
    },
    secondary: {
      main: '#00b2ad'
    }
  }
})

const LayoutUser = (props) => {
  return (
    <ThemeProvider theme={frontTheme}>
      <div style={{ color: 'var(--first)', backgroundColor: '#fff' }}>
        <Header />
        {props.children}
        <Footer />
      </div>
    </ThemeProvider>
  )
}

LayoutUser.propTypes = {
  children: propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.array])
}

export default LayoutUser
